<template>
    <div class="bd-box box-sizing">
        <el-divider><span class="bd-divider">专属域名—专人专用</span></el-divider>
        <div style="color:#f76a1a;font-size: 12px;background: #f5f5f5;padding:10px 10px; text-align: left;margin-top:50px;font-size: 18px;">请仔细阅读如下规则并遵守<br>
            <div style="font-size: 12px;color:#999;line-height: 180%;">
               <font color="black"> 问题Q：我购买了vip或专属域名，为什么还需要购买访问包？</font><br>
                解释A： vip是针对高级功能，专属域名是用户独立专享域名，访问包是访问的消耗，访问量越大，我们服务器成本越高，所以需要单独购买。<br>
              <font color="black"> 问题Q：如果没有访问包，会怎么样？</font><br>
                解释： 如果没有访问包，系统会提示到期或跳转到广告。<br>
              <font color="black">  问题Q：该域名的所有权是属于购买者吗</font> <br>
              <font color="red">解释： 域名的所有权属于购买者，购买之后请及时联系客服进行域名的过户，专属短域名严禁用于违法违规，用户使用带来的后果和责任需要自行承担。</font><br>
              <font color="black"> 问题Q：如果不满意或不合适或不想用，可以退款吗 </font><br>
              <font color="red">解释： 域名一旦购买无法退款。 </font><br>
              <font color="black"> 问题Q：域名有哪些注意事项？</font><br>
              <font color="red">解释： top,vip,xyz的后缀域名在微信会提示非官网，若介意请勿购买，购买之前请把域名发在微信自行检验。</font><br>
            </div>
        </div>
        <div class="bd-head">
          <div class="item">
            <div class="l"><img src="../../assets/images/icon_changes.png"></div>
            <div class="r">
              <div class="title" style="color:red;">支持首页跳转</div>
              <div class="cont">可设定域名的跳转，更短的链接</div>
            </div>
          </div>
            <div class="item">
                <div class="l"><img src="../../assets/images/icon_server.png"></div>
                <div class="r">
                    <div class="title">独立服务器</div>
                    <div class="cont">拥有独享服务器，专门处理您的短网址链接跳转</div>
                </div>
            </div>
            <div class="item">
                <div class="l"><img src="../../assets/images/icon_cdn.png"></div>
                <div class="r">
                    <div class="title">专属CDN加速</div>
                    <div class="cont">加速您每一条短网址，20ms以内延迟，不拥堵</div>
                </div>
            </div>
            <div class="item">
                <div class="l"><img src="../../assets/images/icon_nlimit.png"></div>
                <div class="r">
                    <div class="title">高并发支持</div>
                    <div class="cont">十万人同时点击，也能快速打开</div>
                </div>
            </div>
            <div class="item">
                <div class="l"><img src="../../assets/images/icon_changes.png"></div>
                <div class="r">
                    <div class="title">转换可达10万条</div>
                    <div class="cont">自己的域名，链接随便转，最高可达10万</div>
                </div>
            </div>
            <div class="item">
                <div class="l"><img src="../../assets/images/icon_changes.png"></div>
                <div class="r">
                    <div class="title">电商超级唤醒</div>
                    <div class="cont">支持唤醒手机淘宝，京东，拼多多，支持在微博唤醒</div>
                </div>
            </div>
            <div class="item">
                <div class="l"><img src="../../assets/images/icon_changes.png"></div>
                <div class="r">
                    <div class="title">微信防封保护</div>
                    <div class="cont">持久耐用，被封概率大大降低</div>
                </div>
            </div>
            <div class="item">
                <div class="l"><img src="../../assets/images/icon_changes.png"></div>
                <div class="r">
                    <div class="title">专人专用</div>
                    <div class="cont">只供您一个人使用，不与他人共用</div>
                </div>
            </div>

          <div class="item">
            <div class="l"><img src="../../assets/images/icon_changes.png"></div>
            <div class="r">
              <div class="title">更多特权功能</div>
              <div class="cont">更多功能开发中，敬请期待</div>
            </div>
          </div>

        </div>
        <div class="domain-mode">
          <div class="title">1.选择专属域名 <font color="red" style="font-weight: bold;font-size: 14px;">（可绑定自己在阿里云/华为云/腾讯云购买的域名，请选择自有域名 ）</font></div>
            <div class="box">


                <el-radio-group v-model="selDefaults" @change="selDomainChange">
                    <el-radio class="sel-item" v-for="(item,index) in domainList"  :key="item.id" :label="index" border style="margin-right: 15px;overflow: hidden"  :class="item.bind_domains>0?'ziyou1':''" >

                      <span v-if=" item.bind_domains==0" >{{item.domain.slice(0, 12)}}</span>
                      <span v-if="item.bind_domains>0" >自有域名</span>


                      <span style="color:#f76a1a;font-size:12px;">￥{{item.price}}</span>
                      <span v-if="item.mark" style="color:#fff;font-size:12px;font-weight: 200; display: inline-block;padding:4px 5px; border-radius: 4px; background:#00c800;position:absolute;right:5px;top:10px;">{{item.mark}}</span>
                    </el-radio>


                </el-radio-group>
            </div>
          <div class="box" v-if="selDomain=='xxxx.cn'" style="border: 1px dashed #409EFF;padding:10px;margin-bottom: 20px;background:rgb(245, 245, 245);">
            填写自有域名： <input type="text" v-model="diydomain" style="border:1px solid #409EFF;height:30px;"></input> <span style="font-size: 12px">比如，  ad4.cn 或二级域名 y.ad4.cn ，请自行将域名的 @或y记录 别名解析到 hk.host.ttdwz.cc</span>

          </div>
            <div class="title mb-20">2.您选择的域名是：
              <font color="red" v-if="bind_domains>0">自有域名套餐（绑定{{bind_domains}}个）</font>
              <font color="red" v-if=" bind_domains==0">{{selDomain}}</font>

              ，应付金额：<font color="red">{{dmiPrice}}</font> 元/年，到期时间：<font color="red">{{expireDate | dateFormat('YYYY-MM-DD')}}</font></div>
            <div class="title">3.选择支付方式</div>
            <div class="box">
                <el-radio-group v-model="payType">
                  <el-radio :label="0" border>余额支付，可用余额：{{userInfo.money}}</el-radio>
                </el-radio-group>
               请确保余额足够，如不够，请点击 <a href="/tabs/charge" class="but_charge">充值</a>
            </div>

            <div class="box">
                <el-button  type="primary" :loading="isLoading" @click="submitOrders">提交支付</el-button>
            </div>

           <div class="box">
              提示：自有域名套餐购买完之后，请在左侧专属域名管理--->专属域名列表里进行添加您需要的域名
           </div>
        </div>
        <el-dialog title="订单支付" :visible.sync="payDialog" :close-on-click-modal="false" :close-on-press-escape="false" center width="400px">
            <span>
                <div class="header">
                    <span>当前选择的域名是：</span>
                  <font color="red" v-if="diydomain!=''">自有域名-> {{diydomain}}</font>
                  <font color="red" v-if="bind_domains>0">自有域名套餐（绑定{{bind_domains}}个）</font>
                   <font color="red" v-if="selDomain!='xxxx.cn'  && bind_domains==0">{{selDomain}}</font>

                    <span>，价格：</span>
                    <font color="red">{{dmiPrice}}元/年</font>
                </div>
                <div class="header">二维码有效期：{{qrExpireDate}}</div>
                <div class="pay-qrcode">
                    <div class="icon-box">
                        <i class="iconfont icon-dwzzhifubao1 zfb" v-if="payType===1"></i>
                        <i class="iconfont iconweixindenglu wx" v-if="payType===2"></i>
                    </div>
                    <div class="code-div" ref="payQrCode"></div>
                </div>
            </span>
            <span slot="footer">
                <el-button type="primary" :loading="payLoading" @click="queryPayStatus">查询支付结果</el-button>
            </span>
        </el-dialog>
        <el-dialog title="提示" :visible.sync="noPayDialog" :close-on-click-modal="false" :close-on-press-escape="false" center class="no-pay" width="400px">
            <div class="remind">您还有未支付订单！</div>
            <div class="btn-box"><el-button class="p-btn" type="primary" @click="goPay">前往支付</el-button></div>
            <div class="btn-box">
                <el-popconfirm title="确认取消吗？" @confirm="celOrder">
                    <el-button class="p-btn" type="danger" slot="reference">取消订单</el-button>
                </el-popconfirm>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import QRCode from 'qrcodejs2';

    export default {
        name: "BuyDomain",
        data() {
            return {
                isLoading: false,
                payType: 0,
                selDefaults: 0,
                dmiPrice: '0.00',
                selDomain: '无',
                expireDate: '无',
                qrExpireDate: '无',
                qrExpireSeconds: 0,
                selDomainID: 0,
                diydomain:'',
                bind_domains:0,
                payDialog: false,
                noPayDialog: false,
                payLoading: false,
                qrInterval: null,
                domainList: [],
                orderInfo:{
                    id: 0,
                    qrUrl: '',
                },
              type:0,
              userInfo:{},
            }
        },
        mounted(option) {
            setTimeout(this.getDomainList,200);
            try {
              if (option.type == 1) {
                this.type = 1;
              }
            }catch (e){}
          setTimeout(this.getUserInfo,200);
        },
        methods: {
          async getUserInfo() {
            const {ret,data} = await this.$api.user.getUserInfo();
            if (ret === 1000){
              this.userInfo = data;
            }
          },
            async getDomainList() {
                const {ret,data} = await this.$api.exclusive.getList();
                if (ret === 1000){
                   this.domainList = data.list;
                   if (data.list.length > 0){
                       this.selDomainChange(0);
                   }
                }
            },
            async submitOrders() {
                const id = this.selDomainID;
                const payType = this.payType;

                if (id === 0){
                    this.$message.error("请选择要购买的域名！");
                    return;
                }



                this.isLoading = true;
                const {ret,data} = await this.$api.exclusive.addOrder({id:id,payType: payType,diydomain:this.diydomain});
                this.isLoading = false;
                if (ret === 1000){
                    this.payType = Number(data.payType);
                    this.orderInfo.id = Number(data.id);
                    this.orderInfo.qrUrl = data.qrUrl;
                    this.qrExpireSeconds = data.expTime;
                    //this.showPayDialog();
                    this.$alert('订单已支付成功！', '提示', {
                      confirmButtonText: '确定',
                      type: 'success',
                      callback: action => {
                        console.log(action);
                        window.location.reload(1);
                      }
                    });

                }else if (ret === 901){
                    this.payType = Number(data.payType);
                    this.orderInfo.id = Number(data.id);
                    this.orderInfo.qrUrl = data.qrUrl;
                    this.selDomain = data.domain;
                    this.dmiPrice = data.price;
                    this.qrExpireSeconds = data.expTime;
                    this.expireDate = new Date().setFullYear(new Date().getFullYear()+1);
                    this.noPayDialog = true;
                }
            },
            async queryPayStatus() {
                const id = this.orderInfo.id;
                if (id === 0) {
                    this.$message.error('数据出错！请刷新后重试');
                    return;
                }
                const {ret} = await this.$api.exclusive.queryOrder({id:id});
                if (ret === 1000){
                    this.payDialog = false;
                    this.$alert('订单已支付成功！', '支付结果', {
                        confirmButtonText: '确定',
                        type: 'success',
                        callback: action => {
                            console.log(action);
                        }
                    });
                }else if (ret === 902){
                    this.orderTimedOut();
                }else if (ret === 903){
                    this.$message.warning('订单还未支付！请尽快支付');
                }
            },
            async queryPaymentResults() {
                const id = this.orderInfo.id;
                if (id === 0) {
                    this.$message.error('数据出错！请刷新后重试');
                    return;
                }
                const {ret} = await this.$api.exclusive.queryOrder({id:id});
                if (ret === 1000){
                    this.payDialog = false;
                    this.$alert('订单已支付成功！', '支付结果', {
                        confirmButtonText: '确定',
                        type: 'success',
                        callback: action => {
                            console.log(action);
                        }
                    });
                }else if (ret === 902){
                    this.orderTimedOut();
                }else if (ret === 903){
                    if (this.payDialog){
                        setTimeout(this.queryPaymentResults,1000);
                    }
                }
            },
            async celOrder() {
                const id = this.orderInfo.id;
                if (id === 0) {
                    this.$message.error('数据出错！请刷新后重试');
                    return;
                }
                const {ret} = await this.$api.exclusive.celOrder({id:id});
                if (ret === 1000){
                    this.getDomainList();
                    this.noPayDialog = false;
                    this.$message.success('取消成功！');
                }
            },
            goPay() {
                this.noPayDialog = false;
                this.showPayDialog();
            },
            showPayDialog() {
                this.payDialog = true;
                this.qrCodeCountTime();
                setTimeout(this.bindQRCode,200);
                setTimeout(this.queryPaymentResults,1000);
            },
            selDomainChange(val) {
                const now = new Date().setFullYear(new Date().getFullYear()+1);
                const sel = this.domainList[val];
                this.selDomain = sel.domain;
                this.selDomainID = sel.id;
                this.dmiPrice = sel.price;
                this.expireDate = now;
                this.bind_domains=sel.bind_domains;
            },
            bindQRCode() {
                const txt = this.orderInfo.qrUrl;
                if (txt === '') return;
                this.$refs.payQrCode.innerHTML = '';
                new QRCode(this.$refs.payQrCode, {
                    text: txt,
                    width: 200,
                    height: 200,
                    colorDark: "#333333", //二维码颜色
                    colorLight: "#ffffff", //二维码背景色
                    correctLevel: QRCode.CorrectLevel.L //容错率，L/M/H
                });
            },
            qrCodeCountTime() {
                let $this = this;
                let t = $this.qrExpireSeconds;
                $this.qrExpireDate = Math.floor(Math.floor(t%3600)/60)+"分"+Math.floor(t%60)+"秒";
                $this.qrInterval = setInterval(function () {t--;
                    const min = Math.floor(t%3600);
                    const minute = Math.floor(min/60);//分钟
                    const second = t%60 ;//秒
                    $this.qrExpireDate = minute+"分"+second+"秒";
                    if(t === 0){
                        $this.orderTimedOut();
                    }
                    if (!$this.payDialog){
                        $this.qrExpireSeconds = 0;
                        clearInterval( $this.qrInterval);
                    }
                    console.log($this.qrExpireDate);
                },1000);
            },
            orderTimedOut() {
                if (this.payDialog){
                    this.payDialog = false;
                    this.qrExpireSeconds = 0;
                    clearInterval(this.qrInterval);
                    this.$alert('订单支付超时！请重新下订单', '提示', {
                        confirmButtonText: '确定',
                        type: 'error',
                        callback: action => {
                            console.log(action);
                        }
                    });
                }
            }
        },
    }
</script>

<style scoped>
.order_cate_box{color:#333;font-size: 20px;display: flex;align-items: center;justify-content: center;height:50px;}
.order_cate_box span{display: flex;padding:10px 20px;}
.order_cate_box span.current{display: flex;background:#0C5F9B;color:#fff;}

.ziyou1{background:#dbf2e3;}

    .bd-box{
        width: 100%;
        height: auto;
        padding: 20px;
    }
    .bd-box .bd-divider{
        font-size: 24px;
        font-weight: 200;
        letter-spacing: 5px;
    }
    .bd-box .bd-head{
        width: 100%;
        padding-top: 20px;
    }
    .bd-box .bd-head .item{
        display: inline-block;
        width: 270px;
        height: 100px;
        font-size: 18px;
        margin: 20px 45px;
        border-radius: 8px;
        border: 1px solid #d7dae2;
        vertical-align: top;
    }
    .bd-box .bd-head .item .l{
        display: inline-block;
        width: 60px;
        height: 40px;
        margin: 30px 10px 30px 20px;
        text-align: center;
        line-height: 60px;
        vertical-align: top;
    }
    .bd-box .bd-head .item .r{
        display: inline-block;
        width: 150px;
        height: 70px;
        margin: 15px 20px 15px 10px;
        vertical-align: top;
    }
    .bd-box .bd-head .item .r .title{
        width: 100%;
        height: 25px;
        font-size: 18px;
        font-weight: 500;
    }
    .bd-box .bd-head .item .r .cont{
        width: 150px;
        height: 35px;
        color: #666666;
        font-size: 12px;
        margin-top: 10px;
    }
    .bd-box .domain-mode{
        width: 100%;
        height: auto;
    }
    .bd-box .domain-mode .title{
        width: 100%;
        height: 30px;
        font-size: 18px;
        line-height: 30px;
    }
    .bd-box .domain-mode .box{
        width: 1120px;
        height: auto;
        padding: 20px;
    }
    .sel-item{
        width: 265px;
        margin-left: 0!important;
        margin-bottom: 10px;

    }
    .mb-20{
        margin-bottom: 20px;
    }
    .header{
        width: 100%;
        height: 40px;
        font-size: 16px;
        text-align: center;
    }
    .pay-qrcode{
        width: 200px;
        height: 200px;
        margin: 0 auto;
        position: relative;
    }
    .pay-qrcode .code-div{
        width: 100%;
        height: 100%;
    }
    .pay-qrcode .icon-box{
        width: 40px;
        height: 40px;
        margin: -20px 0 0 -20px;
        border-radius: 50%;
        overflow: hidden;
        text-align: center;
        line-height: 40px;
        background-color: #FFFFFF;
        position: absolute;
        top: 50%;
        left: 50%;
    }
    .pay-qrcode .icon-box i{
        font-size: 40px;
    }
    .pay-qrcode .icon-box i.zfb{
        color: #1196db;
    }
    .pay-qrcode .icon-box i.wx{
        color: #00c800;
    }
    .no-pay{}
    .no-pay .remind{
        width: 100%;
        height: 60px;
        font-size: 16px;
        text-align: center;
    }
    .no-pay .btn-box{
        width: 100%;
        height: 40px;
        text-align: center;
        margin-bottom: 10px;
    }
    .no-pay .btn-box .p-btn{
        width: 200px;
    }
</style>
